__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "lumahealth-webapp-patient";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mui/system", "5.13.1", () => (Promise.all([__webpack_require__.e(8751), __webpack_require__.e(4156), __webpack_require__.e(2425)]).then(() => (() => (__webpack_require__(98751))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(4164), __webpack_require__.e(4156)]).then(() => (() => (__webpack_require__(54164))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(1933), __webpack_require__.e(4156), __webpack_require__.e(4304), __webpack_require__.e(8413)]).then(() => (() => (__webpack_require__(91933))))));
			register("react-singleton-context", "1.0.4", () => (Promise.all([__webpack_require__.e(4156), __webpack_require__.e(4923)]).then(() => (() => (__webpack_require__(44923))))));
			register("react", "17.0.2", () => (__webpack_require__.e(2791).then(() => (() => (__webpack_require__(72791))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};